/* =====================================================================
   Pestivia front-end behaviours.
   - Every section opts in with data-pv="module [module …]".
   - One shared requestAnimationFrame loop drives the scroll scenes, and only
     visits sections that are near the viewport.
   - Horizon scrolls .page-wrapper (not the window) from 990px up, so all scroll
     reads go through getY()/maxY().
   - Sections re-initialise on shopify:section:load so the theme editor works.
   ===================================================================== */
(function () {
  'use strict';
  if (window.PV && window.PV.__v) return;
  var PV = (window.PV = { __v: 1 });
  var doc = document, html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var SQ = window.matchMedia('(min-width: 990px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  /* phones / touch: lighter versions of the heaviest scroll effects */
  var LITE = !FINE || window.matchMedia('(max-width: 760px)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var seg = function (v, a, b) { return clamp((v - a) / (b - a), 0, 1); };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- scroll helpers (Horizon squeeze layout) ---------- */
  function wrapper() { return SQ.matches ? doc.querySelector('.page-wrapper') : null; }
  function getY() { var w = wrapper(); return w ? w.scrollTop : window.pageYOffset || html.scrollTop || 0; }
  function viewH() { var w = wrapper(); return w ? w.clientHeight : window.innerHeight; }
  function maxY() { var w = wrapper(); return w ? Math.max(0, w.scrollHeight - w.clientHeight) : Math.max(0, html.scrollHeight - window.innerHeight); }
  /* layout reads are cached per frame and taken before any module writes styles,
     so the browser lays out once per frame instead of once per module */
  var RC = new Map(), HC = new Map();
  function rectOf(el) { var r = RC.get(el); if (!r) { r = el.getBoundingClientRect(); RC.set(el, r); } return r; }
  function heightOf(el) { var h = HC.get(el); if (h === undefined) { h = el.offsetHeight; HC.set(el, h); } return h; }
  function pinProg(el) { var r = rectOf(el); return clamp(-r.top / Math.max(1, heightOf(el) - viewH()), 0, 1); }
  function prog(el) { var r = rectOf(el), vh = viewH(); return clamp((vh - r.top) / (vh + r.height), 0, 1); }
  PV.getY = getY;

  /* ---------- ant artwork ---------- */
  var ANT = '<svg width="WW" height="HH" viewBox="0 0 64 32" aria-hidden="true"><g class="pv-legA"><path class="pv-leg" d="M29 16 L21 5"/><path class="pv-leg" d="M34 16 L38 28"/><path class="pv-leg" d="M38 16 L47 6"/></g><g class="pv-legB"><path class="pv-leg" d="M29 16 L21 27"/><path class="pv-leg" d="M34 16 L38 4"/><path class="pv-leg" d="M38 16 L47 26"/></g><ellipse cx="15" cy="16" rx="13" ry="8.5" fill="#7A4421"/><ellipse cx="33" cy="16" rx="7.5" ry="4.8" fill="#8A4E26"/><circle cx="47" cy="16" r="6.5" fill="#7A4421"/><path d="M51 12 Q57 3 63 5" stroke="#8A5A34" stroke-width="1.6" fill="none"/><path d="M51 20 Q57 29 63 27" stroke="#8A5A34" stroke-width="1.6" fill="none"/></svg>';
  var ant = function (w) { return ANT.replace('WW', w).replace('HH', w / 2); };

  /* ---------- module registry + shared loop ---------- */
  var mods = {}, live = [], ctx = { y: 0, dy: 0, vel: 0, vh: 0, t: 0 };
  var vis = new IntersectionObserver(function (en) {
    en.forEach(function (e) { e.target.__pvVis = e.isIntersecting; });
  }, { rootMargin: '100% 0px 100% 0px' });

  function initEl(el) {
    (el.getAttribute('data-pv') || '').split(/\s+/).forEach(function (name) {
      if (!name || !mods[name]) return;
      el.__pv = el.__pv || {};
      if (el.__pv[name]) return;
      var api;
      try { api = mods[name](el) || {}; } catch (err) { console.error('[pv:' + name + ']', err); return; }
      var inst = { el: el, name: name, api: api };
      el.__pv[name] = inst;
      live.push(inst);
      if (!api.always) { el.__pvVis = true; vis.observe(el); }
    });
  }
  function initRoot(scope) {
    scope = scope || doc;
    var list = $$('[data-pv]', scope);
    if (scope.getAttribute && scope.getAttribute('data-pv')) list.unshift(scope);
    list.forEach(initEl);
    observeReveals(scope);
    wake = Math.max(wake, 30);
  }
  function destroyRoot(scope) {
    live = live.filter(function (inst) {
      if (scope === inst.el || scope.contains(inst.el)) {
        try { inst.api.destroy && inst.api.destroy(); } catch (e) {}
        vis.unobserve(inst.el);
        if (inst.el.__pv) delete inst.el.__pv[inst.name];
        return false;
      }
      return true;
    });
  }
  PV.mods = mods; PV.init = initRoot; PV.destroy = destroyRoot;

  /* frames only run while the page moves (plus a short tail), or while a module
     reports it is still animating on its own (busy) */
  var lastY = null, wake = 60;
  function wakeUp() { wake = Math.max(wake, 30); }
  PV.wake = wakeUp;
  window.addEventListener('resize', wakeUp);
  function tick(t) {
    RC.clear(); HC.clear();
    var y = getY(), i, m;
    if (lastY === null) lastY = y;
    ctx.dy = y - lastY; lastY = y; ctx.y = y; ctx.vel += (ctx.dy - ctx.vel) * 0.15; ctx.vh = viewH(); ctx.t = t;
    if (Math.abs(ctx.dy) > 0.1 || Math.abs(ctx.vel) > 0.05) wake = Math.max(wake, 12);
    var run = wake > 0;
    if (wake > 0) wake--;
    var todo = [];
    for (i = 0; i < live.length; i++) {
      m = live[i];
      if (!m.api.frame || m.el.__pvVis === false) continue;
      if (!run && !(m.api.busy && m.api.busy())) continue;
      todo.push(m);
    }
    if (run || todo.length || cur) {
      /* read phase */
      ctx.maxY = maxY();
      for (i = 0; i < todo.length; i++) { m = todo[i]; rectOf(m.el); heightOf(m.el); if (m.api.measure) try { m.api.measure(ctx); } catch (e) {} }
      /* write phase */
      core(ctx);
      for (i = 0; i < todo.length; i++) {
        m = todo[i];
        try { m.api.frame(ctx); } catch (err) { console.error('[pv:' + m.name + ']', err); m.api.frame = null; }
      }
    }
    requestAnimationFrame(tick);
  }

  /* ---------- core: progress bar, header hide/show, cursor ---------- */
  var progressEl = null, navHidden = false, cur = null, mx = -100, my = -100, cx = -100, cy = -100, cang = 0, hdrEl = null, sceneEl;
  function core(c) {
    if (!hdrEl || !hdrEl.isConnected) { hdrEl = $('[data-pv-header]'); sceneEl = $('.pv-scene'); }
    var hdr = hdrEl;
    if (!progressEl) { progressEl = $('.pv-progress'); }
    if (progressEl) progressEl.style.transform = 'scaleX(' + (c.y / Math.max(1, c.maxY)) + ')';
    if (hdr) {
      var scene = sceneEl && sceneEl.isConnected ? sceneEl : null;
      var start = scene ? heightOf(scene) : 300;
      if (c.y > start && Math.abs(c.dy) > 3) {
        var hide = c.dy > 0;
        if (hide !== navHidden && !doc.activeElement.closest('.pvh__mob')) { navHidden = hide; hdr.classList.toggle('hide', hide); }
      } else if (c.y < 100 && navHidden) { navHidden = false; hdr.classList.remove('hide'); }
    }
    if (cur && cur.isConnected) {
      var ox = cx, oy = cy; cx += (mx - cx) * 0.12; cy += (my - cy) * 0.12;
      var mv = Math.hypot(cx - ox, cy - oy);
      if (mv > 0.4) cang = Math.atan2(cy - oy, cx - ox) * 180 / Math.PI;
      cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px) rotate(' + cang + 'deg)';
      cur.classList.toggle('still', mv < 0.4);
    }
  }

  /* ---------- reveals + counters ---------- */
  var revealIO = new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  var countIO = new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      var el = e.target, to = parseFloat(el.getAttribute('data-count-to')), dec = +el.getAttribute('data-dec') || 0, t0 = performance.now();
      if (REDUCED || isNaN(to)) { el.textContent = (isNaN(to) ? 0 : to).toFixed(dec); return; }
      (function step(t) { var k = Math.min(1, (t - t0) / 1400), v = to * (1 - Math.pow(1 - k, 3)); el.textContent = v.toFixed(dec); if (k < 1) requestAnimationFrame(step); })(t0);
    });
  }, { threshold: 0.5 });
  function observeReveals(scope) {
    $$('.pv-rv:not(.in), [data-pv-in]:not(.in)', scope).forEach(function (el) { revealIO.observe(el); });
    $$('[data-count-to]', scope).forEach(function (el) {
      if (el.__pvCount) return;
      el.__pvCount = 1;
      if (!REDUCED) el.textContent = (0).toFixed(+el.getAttribute('data-dec') || 0);
      countIO.observe(el);
    });
  }

  /* =====================================================================
     HERO SCENE
     ===================================================================== */
  mods.hero = function (el) {
    var pin = $('.pv-scene__pin', el), cv = $('canvas', el), g = cv.getContext('2d');
    var rig = $('.pv-rig', el), hand = $('[data-hand]', el), floor = $('[data-floor]', el), reveal = $('.pv-reveal', el);
    var cue = $('.pv-scene__cue', el), skip = $('.pv-scene__skip', el), word = $('[data-word]', el), antsBox = $('[data-ants]', el);
    var lines = $$('.pv-scene__line', el), hdr = $('[data-pv-header]');
    var W = 0, H = 0, DPR = 1, floorY = 0, S = 1, p = 0, parts = [], puffs = [], pileX = 0, heroAnts = [], grains = [], i;
    var painted = true, lastClip = '', lastHand = '', lastP = -1;
    var showAnts = el.getAttribute('data-ants') !== 'off';
    if (antsBox) antsBox.innerHTML = '';
    if (antsBox && showAnts) {
      for (i = 0; i < (LITE ? 4 : 6); i++) {
        var d = doc.createElement('div'); d.className = 'pv-ant'; d.innerHTML = '<div class="pv-crumb"></div>' + ant(40); antsBox.appendChild(d);
        heroAnts.push({ el: d, side: i % 2 ? 1 : -1, lag: (i >> 1) * 0.035, row: (i >> 1) * 7 });
      }
    }
    for (i = 0; i < 90; i++) grains.push([Math.random() * 2 - 1, Math.random(), Math.random()]);

    function size() {
      /* phones: 1.5x is visually the same for dust, and ~45% fewer pixels to clear */
      DPR = Math.min(FINE ? 2 : 1.5, window.devicePixelRatio || 1);
      painted = true; lastClip = lastHand = '';
      W = pin.clientWidth; H = pin.clientHeight;
      cv.width = W * DPR; cv.height = H * DPR; g.setTransform(DPR, 0, 0, DPR, 0, 0);
      rig.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      S = Math.max(0.55, Math.min(W / 1440, H / 900) * 1.15);
      floorY = H * (W < 700 ? 0.84 : 0.8);
      floor.style.top = floorY + 'px';
    }
    function pose() {
      var mob = W < 700, gx = W * (mob ? 0.74 : 0.66), gy = H * (mob ? 0.44 : 0.3);
      var enter = ease(seg(p, 0.02, 0.2)), exit = ease(seg(p, 0.74, 0.86));
      var tilt = ease(seg(p, 0.18, 0.3)) - ease(seg(p, 0.7, 0.78));
      var x = gx + (1 - enter) * W * 0.5 + exit * W * 0.55, y = gy - (1 - enter) * H * 0.7 - exit * H * 0.8;
      var wob = tilt > 0.95 ? Math.sin(performance.now() / 260) * 2.5 : 0;
      return { x: x, y: y, ang: -92 - tilt * 40 + wob, pouring: tilt > 0.85 && p > 0.28 && p < 0.72 };
    }
    function spout(ps) {
      var a = ps.ang * Math.PI / 180, lx = 0, ly = -200;
      return { x: ps.x + (lx * Math.cos(a) - ly * Math.sin(a)) * S, y: ps.y + (lx * Math.sin(a) + ly * Math.cos(a)) * S, dir: a };
    }
    function pileH() { return seg(p, 0.3, 0.7) * Math.min(80, H * 0.09, W * 0.1); }
    function pileAt(x, h) { var w = h * 3.4 + 24, t = (x - pileX) / (w / 2); return Math.abs(t) >= 1 ? 0 : h * Math.pow(1 - t * t, 0.85); }

    function frame() {
      var rect = rectOf(el), total = heightOf(el) - H;
      p = clamp(-rect.top / Math.max(1, total), 0, 1);
      if (hdr) { var light = p > 0.9 || rect.bottom < 80; hdr.classList.toggle('pvh--light', light); hdr.classList.toggle('pvh--dark', !light); }
      if (rect.bottom <= 0) return;
      var ps = pose();
      var handT = 'translate(' + ps.x.toFixed(1) + ' ' + ps.y.toFixed(1) + ') rotate(' + ps.ang.toFixed(2) + ') scale(' + S + ') translate(-90 -200)';
      if (handT !== lastHand) { hand.setAttribute('transform', handT); lastHand = handT; }
      var sp = spout(ps);
      if (p < 0.3 || !pileX) pileX = sp.x;
      var h = pileH();
      /* nothing on the canvas and nothing to draw: skip the full-screen clear */
      if (!painted && !ps.pouring && !parts.length && !puffs.length && h <= 0.5 && p === lastP) return;
      lastP = p;
      g.clearRect(0, 0, W, H);
      painted = ps.pouring || parts.length > 0 || puffs.length > 0 || h > 0.5;
      var k, j;
      if (ps.pouring && !REDUCED) for (k = 0; k < (LITE ? 3 : 7); k++) parts.push({ x: sp.x + (Math.random() - 0.5) * 10 * S, y: sp.y + Math.random() * 4, vx: (Math.random() - 0.5) * 0.5 + Math.cos(sp.dir) * 0.6, vy: 1 + Math.random(), r: 0.8 + Math.random() * 1.8 });
      g.fillStyle = '#F1E9CF';
      for (j = parts.length - 1; j >= 0; j--) {
        var q = parts[j]; q.vy += 0.38; q.vx *= 0.99; q.x += q.vx; q.y += q.vy;
        var ground = floorY - pileAt(q.x, h);
        if (q.y >= ground) { if (Math.random() < 0.12) puffs.push({ x: q.x, y: ground, r: 2, a: 0.5 }); parts.splice(j, 1); continue; }
        g.globalAlpha = 0.9; g.beginPath(); g.arc(q.x, q.y, q.r, 0, 6.283); g.fill();
      }
      for (j = puffs.length - 1; j >= 0; j--) { var f = puffs[j]; f.r += 0.6; f.a -= 0.02; if (f.a <= 0) { puffs.splice(j, 1); continue; } g.globalAlpha = f.a * 0.5; g.beginPath(); g.arc(f.x, f.y - f.r * 0.4, f.r, 0, 6.283); g.fill(); }
      g.globalAlpha = 1;
      if (h > 0.5) {
        var w = h * 3.4 + 24;
        g.beginPath(); g.moveTo(pileX - w / 2, floorY);
        for (var xx = -w / 2; xx <= w / 2; xx += 3) g.lineTo(pileX + xx, floorY - pileAt(pileX + xx, h));
        g.lineTo(pileX + w / 2, floorY); g.closePath();
        var gr = g.createLinearGradient(0, floorY - h, 0, floorY); gr.addColorStop(0, '#F7F1DC'); gr.addColorStop(1, '#D8CDA6');
        g.fillStyle = gr; g.fill(); g.fillStyle = '#CDBF93';
        grains.forEach(function (a) { var gx = pileX + a[0] * w / 2 * 0.9, gy = floorY - pileAt(gx, h) * a[1]; g.globalAlpha = 0.5 * a[2]; g.fillRect(gx, gy, 1.6, 1.6); });
        g.globalAlpha = 1;
      }
      var edgeGap = (h * 3.4 + 24) / 2 + 10;
      heroAnts.forEach(function (a) {
        var come = ease(seg(p, 0.36 + a.lag, 0.58 + a.lag)), go = ease(seg(p, 0.62 + a.lag, 0.84 + a.lag));
        var start = a.side < 0 ? -80 : W + 80, target = pileX + a.side * (edgeGap + a.row * 4);
        var x = go > 0 ? target + (start - target) * go : start + (target - start) * come;
        a.el.style.transform = 'translate(' + (x - 20) + 'px,' + (floorY - 18 + a.row * 0.6) + 'px) scaleX(' + (go > 0 ? a.side : -a.side) + ')';
        a.el.classList.toggle('carry', go > 0);
        a.el.style.opacity = (come > 0 && go < 1) ? 1 : 0;
      });
      lines.forEach(function (l) { var n = +l.getAttribute('data-line'); l.classList.toggle('on', n === 0 ? p < 0.22 : (p > 0.28 && p < 0.68)); });
      if (cue) cue.style.opacity = p < 0.05 ? 1 : 0;
      if (skip) skip.style.opacity = p > 0.78 ? 0 : 1;
      if (word) word.style.transform = 'translateX(' + (-p * 28) + '%)';
      var rv = ease(seg(p, 0.8, 0.97)), R = Math.hypot(W, H) * 1.05 * rv;
      var clip = 'circle(' + R.toFixed(1) + 'px at ' + pileX.toFixed(1) + 'px ' + floorY.toFixed(1) + 'px)';
      if (clip !== lastClip) { reveal.style.clipPath = clip; lastClip = clip; }
      reveal.classList.toggle('on', rv > 0.55);
      reveal.style.pointerEvents = rv > 0.55 ? 'auto' : 'none';
    }
    size(); window.addEventListener('resize', size);
    return {
      frame: frame,
      /* keep drawing while powder is falling or the pour wobble is on, even if the page is still */
      busy: function () { return parts.length > 0 || puffs.length > 0 || (p > 0.18 && p < 0.78); },
      destroy: function () {
        window.removeEventListener('resize', size);
        if (hdr) { hdr.classList.add('pvh--light'); hdr.classList.remove('pvh--dark'); }
      }
    };
  };

  /* =====================================================================
     STATEMENT (word by word)
     ===================================================================== */
  mods.statement = function (el) {
    var words = $$('.w', el), imgs = $$('.pv-stmt__sachets img', el), ops = [], lastSp = -1;
    return {
      frame: function () {
        var sp = pinProg(el);
        if (sp === lastSp) return;
        lastSp = sp;
        words.forEach(function (w, i) {
          var t = clamp(sp * 1.25 * words.length - i, 0, 1), o = Math.round((0.14 + t * 0.86) * 100) / 100;
          if (ops[i] !== o) { w.style.opacity = o; ops[i] = o; }
        });
        imgs.forEach(function (im, i) { var d = [1, -1, 1][i % 3]; im.style.transform = 'translateY(' + ((0.5 - sp) * [180, 240, 140][i % 3]) + 'px) rotate(' + (d * (sp * 40 - 12)) + 'deg)'; });
      }
    };
  };

  /* =====================================================================
     STICKY BENEFITS
     ===================================================================== */
  mods.benefits = function (el) {
    var items = $$('.pv-ben__item', el), imgs = $$('.pv-ben__vis .pv-ben__slide', el), dots = $$('.pv-ben__dots b', el), num = $('.pv-ben__num', el), idx = -1;
    return {
      measure: function () { items.forEach(rectOf); },
      frame: function (c) {
        var best = 0, bd = 1e9;
        items.forEach(function (it, i) { var r = rectOf(it), dd = Math.abs(r.top + r.height / 2 - c.vh / 2); if (dd < bd) { bd = dd; best = i; } });
        if (best === idx) return;
        idx = best;
        items.forEach(function (it, i) { it.classList.toggle('on', i === best); });
        imgs.forEach(function (im, i) { im.classList.toggle('on', i === best); });
        dots.forEach(function (d, i) { d.style.transform = 'scaleX(' + (i <= best ? 1 : 0) + ')'; });
        if (num) num.textContent = ('0' + (best + 1)).slice(-2);
      }
    };
  };

  /* =====================================================================
     HORIZONTAL PINNED STEPS
     ===================================================================== */
  mods.hsteps = function (el) {
    var track = $('.pv-hs__track', el), bar = $('.pv-hs__bar b', el), dist = 0, pars = $$('[data-par]', el);
    function size() { dist = Math.max(0, track.scrollWidth - window.innerWidth); el.style.height = (viewH() + dist) + 'px'; }
    size(); window.addEventListener('resize', size); window.addEventListener('load', size);
    $$('img', el).forEach(function (im) { if (!im.complete) im.addEventListener('load', size, { once: true }); });
    return {
      measure: function () { if (!LITE) pars.forEach(function (im) { rectOf(im.parentNode); }); },
      frame: function () {
        var hp = pinProg(el);
        track.style.transform = 'translateX(' + (-hp * dist) + 'px)';
        if (bar) bar.style.width = (hp * 100) + '%';
        if (!LITE) pars.forEach(function (im) { var r = rectOf(im.parentNode), k = (r.left + r.width / 2) / window.innerWidth - 0.5; im.style.transform = 'translateX(' + (k * -60) + 'px) rotate(' + (k * -14) + 'deg)'; });
      },
      destroy: function () { window.removeEventListener('resize', size); window.removeEventListener('load', size); el.style.height = ''; }
    };
  };

  /* =====================================================================
     CHIPS MARQUEE (reacts to scroll speed)
     ===================================================================== */
  mods.chips = function (el) {
    var skew = $('.pv-chips__skew', el), track = $('.pv-chips__track', el), anims = null, lastRate = 1, lastSk = '';
    return {
      frame: function (c) {
        if (REDUCED || LITE) return;
        var sk ='skewX(' + clamp(-c.vel * 0.25, -12, 12).toFixed(1) + 'deg)';
        if (skew && sk !== lastSk) { skew.style.transform = sk; lastSk = sk; }
        if (!anims && track && track.getAnimations) anims = track.getAnimations();
        var rate = Math.round((1 + Math.min(6, Math.abs(c.vel) * 0.12)) * 10) / 10;
        if (anims && rate !== lastRate) { anims.forEach(function (a) { a.playbackRate = rate; }); lastRate = rate; }
      }
    };
  };

  /* =====================================================================
     PROGRESS VARIABLES (--p / --e) for slide-in cards
     ===================================================================== */
  mods.prog = function (el) {
    return { frame: function () { var q = prog(el); el.style.setProperty('--p', q.toFixed(4)); el.style.setProperty('--e', clamp(q * 2.2, 0, 1).toFixed(4)); } };
  };

  /* =====================================================================
     REVIEWS WALL
     ===================================================================== */
  mods.say = function (el) {
    var big = $('.pv-say__big', el), cols = $$('.pv-say__col', el);
    return {
      frame: function () {
        if (REDUCED) return;
        var rp = prog(el);
        if (big) big.style.transform = 'translateX(' + (8 - rp * 55) + '%)';
        if (!LITE) cols.forEach(function (c) { c.style.transform = 'translateY(' + ((0.5 - rp) * +c.getAttribute('data-speed')) + 'px)'; });
      }
    };
  };

  /* =====================================================================
     DRIFTING GALLERY
     ===================================================================== */
  mods.drift = function (el) {
    var r1 = $$('.pv-drift__row', el)[0], r2 = $$('.pv-drift__row', el)[1];
    return {
      frame: function () {
        if (REDUCED) return;
        var dp = prog(el);
        if (r1) r1.style.transform = 'translateX(' + (-dp * 30) + '%)';
        if (r2) r2.style.transform = 'translateX(' + (dp * 30 - 30) + '%)';
      }
    };
  };

  /* =====================================================================
     FOOTER BIG LETTERS
     ===================================================================== */
  mods.foot = function (el) {
    var fb = $('.pv-foot__big', el);
    if (!fb || fb.__split) return {};
    fb.__split = 1;
    fb.innerHTML = fb.textContent.split('').map(function (ch, i) { return '<span style="transition-delay:' + (i * 0.05) + 's">' + esc(ch === ' ' ? ' ' : ch) + '</span>'; }).join('');
    var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { fb.classList.add('in'); o.disconnect(); } }, { threshold: 0.3 });
    o.observe(fb);
    return { destroy: function () { o.disconnect(); } };
  };

  /* =====================================================================
     CARD TILT + SHINE
     ===================================================================== */
  mods.tilt = function (el) {
    if (!FINE || REDUCED) return {};
    var sh = doc.createElement('div'); sh.className = 'pv-card__shine'; el.appendChild(sh);
    function move(e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 8) + 'deg) rotateY(' + ((x - 0.5) * 10) + 'deg) translateY(-6px)';
      el.style.setProperty('--mx', x * 100 + '%'); el.style.setProperty('--my', y * 100 + '%');
    }
    function leave() { el.style.transform = ''; }
    el.addEventListener('mousemove', move); el.addEventListener('mouseleave', leave);
    return { destroy: function () { el.removeEventListener('mousemove', move); el.removeEventListener('mouseleave', leave); sh.remove(); } };
  };

  /* =====================================================================
     STICKY BUY BAR
     ===================================================================== */
  mods.buybar = function (el) {
    var mode = el.getAttribute('data-mode') || 'hero', hideSel = el.getAttribute('data-hide'), hideEl = hideSel ? $(hideSel) : null, hideVisible = false, o = null;
    if (hideEl) { o = new IntersectionObserver(function (en) { hideVisible = en[0].isIntersecting; }, { threshold: 0.15 }); o.observe(hideEl); }
    var tEl = null, sceneEl2 = null;
    function refs() { if (!tEl || !tEl.isConnected) tEl = $('[data-pv-atc-main]'); if (!sceneEl2 || !sceneEl2.isConnected) sceneEl2 = $('.pv-scene'); }
    return {
      always: true,
      measure: function () { refs(); if (mode === 'atc') { if (tEl) rectOf(tEl); } else if (sceneEl2) rectOf(sceneEl2); },
      frame: function (c) {
        var show = false;
        refs();
        if (mode === 'atc') {
          show = !!tEl && rectOf(tEl).bottom < 0 && c.y < c.maxY - c.vh * 1.2;
        } else {
          show = (sceneEl2 ? rectOf(sceneEl2).bottom < 0 : c.y > c.vh * 0.9) && !hideVisible && c.y < c.maxY - c.vh * 0.8;
        }
        el.classList.toggle('show', show);
      },
      destroy: function () { o && o.disconnect(); }
    };
  };

  /* =====================================================================
     HOME ORDER SECTION — switch between products
     ===================================================================== */
  mods.order = function (el) {
    var panels = $$('[data-panel]', el), gals = $$('[data-gal]', el), picks = $$('[data-pick]', el);
    function select(handle) {
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== handle; });
      gals.forEach(function (p) { p.hidden = p.getAttribute('data-gal') !== handle; });
      picks.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pick') === handle); });
    }
    function click(e) { var b = e.target.closest('[data-pick]'); if (b && el.contains(b)) { e.preventDefault(); select(b.getAttribute('data-pick')); } }
    el.addEventListener('click', click);
    return { destroy: function () { el.removeEventListener('click', click); } };
  };

  /* =====================================================================
     BUY BOX — quantity tiers, variant options, hidden inputs
     ===================================================================== */
  mods.buybox = function (el) {
    var jsonEl = $('script[data-pv-variants]', el), variants = [], sel = [], qty = 1;
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }
    var groups = $$('[data-pv-option]', el);
    groups.forEach(function (gr, i) { var on = $('[aria-checked="true"]', gr); sel[i] = on ? on.getAttribute('data-value') : null; });
    var tiers = $$('.pv-tier', el);
    var qtyBox = $('[data-pv-qty]', el), dealTotal = $('[data-pv-deal-total]', el), nowEl = $('[data-pv-now]', el);

    /* shop money format, e.g. "${{amount}}" */
    function money(cents) {
      var fmt = (qtyBox && qtyBox.getAttribute('data-money')) || '${{amount}}', v = (cents / 100);
      var withSep = function (n, d, th, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return withSep(v, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return withSep(v, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return withSep(v, 0, '.', ',');
        return withSep(v, 2, ',', '.');
      });
    }

    function setQty(n) {
      qty = Math.max(1, Math.min(99, n | 0));
      n = qty;
      $$('input[name="quantity"]', el).forEach(function (inp) { if (!inp.hasAttribute('data-pv-fixed')) inp.value = n; });
      tiers.forEach(function (t) { t.setAttribute('aria-pressed', +t.getAttribute('data-qty') === n); });
      var t = tiers.filter(function (x) { return +x.getAttribute('data-qty') === n; })[0];
      var label = t && t.getAttribute('data-total') ? ' · ' + t.getAttribute('data-total') : '';
      if (qtyBox) {
        var unit = +qtyBox.getAttribute('data-unit') || 0, dq = +qtyBox.getAttribute('data-deal-qty') || 2, dp = +qtyBox.getAttribute('data-deal-pct') || 0;
        var full = unit * n, deal = dp > 0 && n >= dq, pay = deal ? Math.round(full * (100 - dp) / 100) : full;
        var cnt = $('[data-pv-qty-n]', qtyBox); if (cnt) cnt.textContent = n;
        var dealBtn = $('.pv-deal', qtyBox); if (dealBtn) dealBtn.setAttribute('aria-pressed', deal);
        qtyBox.classList.toggle('is-deal', deal);
        /* price line: unit price for 1; "was / now" totals for more */
        if (dealTotal && nowEl) {
          if (n > 1) { dealTotal.hidden = false; dealTotal.innerHTML = (deal ? '<s>' + esc(money(full)) + '</s> ' : '') + '<b>' + esc(money(pay)) + '</b> <small>for ' + n + '</small>'; nowEl.classList.add('is-unit'); }
          else { dealTotal.hidden = true; nowEl.classList.remove('is-unit'); }
        }
        if (!t) label = n > 1 ? ' · ' + money(pay) : '';
      }
      $$('[data-pv-add-total]', el).forEach(function (b) { b.textContent = label; });
    }
    function currentVariant() {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    function applyVariant(v) {
      if (!v) return;
      $$('input[name="id"]', el).forEach(function (inp) { inp.value = v.id; });
      $$('[data-pv-now]', el).forEach(function (n) { n.textContent = v.price; });
      if (qtyBox && v.cents != null) qtyBox.setAttribute('data-unit', v.cents);
      $$('[data-pv-compare]', el).forEach(function (n) { n.textContent = v.compare || ''; n.hidden = !v.compare; });
      $$('[data-pv-save]', el).forEach(function (n) { n.textContent = v.save ? 'Save ' + v.save + '%' : ''; n.hidden = !v.save; });
      tiers.forEach(function (t, i) {
        var d = v.tiers && v.tiers[i]; if (!d) return;
        t.setAttribute('data-total', d.total);
        var pEl = $('.pv-tier__p', t); if (pEl) pEl.innerHTML = (d.was ? '<s>' + esc(d.was) + '</s>' : '') + esc(d.total);
      });
      $$('button[name="add"]', el).forEach(function (b) {
        var lab = $('[data-pv-add-label]', b);
        b.disabled = !v.available;
        if (lab) lab.textContent = v.available ? b.getAttribute('data-label') : b.getAttribute('data-sold');
      });
      $$('[data-pv-add-total]', el).forEach(function (b) { b.hidden = !v.available; });
      setQty(qty);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      if (typeof v.media === 'number' && v.media >= 0) { var ga = $('[data-pv="gallery"]', el.closest('[data-pv-pdp]') || el); if (ga && ga.__pv && ga.__pv.gallery) ga.__pv.gallery.api.showVariant(v.media); }
    }
    function click(e) {
      var t = e.target.closest('.pv-tier'); if (t && el.contains(t)) { setQty(+t.getAttribute('data-qty')); return; }
      var q = e.target.closest('[data-pv-qty] [data-q]'); if (q && el.contains(q)) { setQty(qty + +q.getAttribute('data-q')); return; }
      var qs = e.target.closest('[data-pv-qty] [data-q-set]'); if (qs && el.contains(qs)) { setQty(qty >= +qs.getAttribute('data-q-set') ? 1 : +qs.getAttribute('data-q-set')); return; }
      var b = e.target.closest('[data-pv-option] [data-value]');
      if (b && el.contains(b)) {
        var gr = b.closest('[data-pv-option]'), i = +gr.getAttribute('data-pv-option');
        $$('[data-value]', gr).forEach(function (x) { x.setAttribute('aria-checked', x === b); });
        sel[i] = b.getAttribute('data-value');
        applyVariant(currentVariant());
      }
    }
    el.addEventListener('click', click);
    if (tiers.length) { var pre = tiers.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0]; setQty(pre ? +pre.getAttribute('data-qty') : +tiers[0].getAttribute('data-qty')); }
    else if (qtyBox) setQty(1);
    return { destroy: function () { el.removeEventListener('click', click); } };
  };

  /* =====================================================================
     PRODUCT GALLERY (slides, thumbs, arrows, swipe, hover zoom)
     ===================================================================== */
  mods.gallery = function (el) {
    var slidesEl = $('.pv-pd__slides', el), allSlides = $$('.pv-pd__slide', el), allThumbs = $$('.pv-pd__thumbs button', el), dotsEl = $('.pv-pd__dots', el), stage = $('.pv-pd__stage', el), idx = 0;
    var slides, thumbs, dots, n;
    /* variant photos of unselected variants are [hidden]; only visible ones count */
    function refresh() {
      slides = allSlides.filter(function (s) { return !s.hidden; });
      thumbs = allThumbs.filter(function (b) { return !b.hidden; });
      n = slides.length;
      if (dotsEl) { dotsEl.innerHTML = slides.map(function () { return '<i></i>'; }).join(''); dots = $$('i', dotsEl); } else dots = [];
    }
    function go(i) {
      if (!n) return;
      idx = (i + n) % n;
      slidesEl.style.transform = 'translateX(' + (-idx * 100) + '%)';
      slides.forEach(function (sl, k) { if (k === idx) sl.setAttribute('data-active', ''); else sl.removeAttribute('data-active'); });
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === idx); });
    }
    function showVariant(pos) {
      var key = String(pos), match = allSlides.some(function (s) { return s.getAttribute('data-vm') === key; });
      if (!match) return;
      allSlides.concat(allThumbs).forEach(function (x) { var vm = x.getAttribute('data-vm'); if (vm !== null) x.hidden = vm !== key; });
      refresh();
      go(slides.findIndex(function (s) { return s.getAttribute('data-vm') === key; }));
    }
    refresh();
    var sx = null;
    function click(e) {
      var t = e.target.closest('.pv-pd__thumbs button'); if (t && el.contains(t)) return go(thumbs.indexOf(t));
      if (e.target.closest('[data-prev]')) return go(idx - 1);
      if (e.target.closest('[data-next]')) return go(idx + 1);
    }
    function key(e) { if (!e.target.closest('.pv-pd__thumbs')) return; if (e.key === 'ArrowRight' || e.key === 'ArrowDown') go(idx + 1); if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') go(idx - 1); }
    function ts(e) { sx = e.touches[0].clientX; }
    function te(e) { if (sx === null) return; var d = e.changedTouches[0].clientX - sx; if (Math.abs(d) > 40) go(idx + (d < 0 ? 1 : -1)); sx = null; }
    function mm(e) { var s = slides[idx], r = s.getBoundingClientRect(), im = $('img', s); if (!im || s.classList.contains('pv-pd__slide--full')) return; s.classList.add('zoom'); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; im.style.transform = 'scale(1.8)'; }
    function ml() { slides.forEach(function (s) { s.classList.remove('zoom'); var im = $('img', s); if (im) im.style.transform = ''; }); }
    el.addEventListener('click', click); el.addEventListener('keydown', key);
    if (stage) { stage.addEventListener('touchstart', ts, { passive: true }); stage.addEventListener('touchend', te); if (FINE) { stage.addEventListener('mousemove', mm); stage.addEventListener('mouseleave', ml); } }
    go(0);
    return { go: go, showVariant: showVariant, destroy: function () { el.removeEventListener('click', click); el.removeEventListener('keydown', key); } };
  };

  /* =====================================================================
     INSIDE THE BOX (pinned)
     ===================================================================== */
  mods.box = function (el) {
    var hero = $('.pv-box__hero', el), stage = $('.pv-box__stage', el), grid = $('.pv-box__grid', el), countEl = $('.pv-box__count', el);
    var total = +el.getAttribute('data-count') || 0, tiles = $$('img', grid).map(function (im, i) { return { el: im, r: (Math.random() - 0.5) * 60, i: i, dx: 0, dy: 0 }; }), n = tiles.length;
    function measure() {
      var st = stage.getBoundingClientRect();
      tiles.forEach(function (t) { t.el.style.transform = 'none'; var r = t.el.getBoundingClientRect(); t.dx = (st.left + st.width / 2) - (r.left + r.width / 2); t.dy = (st.top + st.height / 2) - (r.top + r.height / 2); });
    }
    requestAnimationFrame(measure); window.addEventListener('resize', measure); window.addEventListener('load', measure);
    return {
      frame: function () {
        var bp = pinProg(el), heroT = ease(clamp(bp / 0.35, 0, 1));
        if (hero) { hero.style.transform = 'translate(-50%,-50%) scale(' + (1 - heroT * 0.55) + ') translateY(' + (-heroT * 30) + '%) rotate(' + (-heroT * 8) + 'deg)'; hero.style.opacity = 1 - clamp((bp - 0.25) / 0.2, 0, 1) * 0.85; }
        tiles.forEach(function (t) {
          var s = t.i / Math.max(1, n - 1), tt = ease(clamp((bp - 0.2 - s * 0.45) / 0.25, 0, 1));
          if (LITE) {
            /* phones: each pack just fades/scales in once (CSS transition) instead of flying every frame */
            var on = tt > 0.5;
            if (t.on !== on) {
              t.on = on;
              t.el.style.transition = 'opacity .45s ease, transform .45s cubic-bezier(.2,.8,.2,1)';
              t.el.style.opacity = on ? 1 : 0;
              t.el.style.transform = on ? 'none' : 'scale(.6)';
            }
            return;
          }
          t.el.style.opacity = tt;
          t.el.style.transform = 'translate(' + (t.dx * (1 - tt)) + 'px,' + (t.dy * (1 - tt)) + 'px) scale(' + (0.3 + tt * 0.7) + ') rotate(' + (t.r * (1 - tt)) + 'deg)';
        });
        if (countEl) countEl.textContent = Math.round(total * ease(clamp((bp - 0.2) / 0.65, 0, 1)));
      },
      destroy: function () { window.removeEventListener('resize', measure); window.removeEventListener('load', measure); }
    };
  };

  /* =====================================================================
     SACHET ANATOMY (pinned)
     ===================================================================== */
  mods.ana = function (el) {
    var st = $('.pv-ana__stage', el), img = $('.pv-ana__img', el), svgEl = $('.pv-ana__svg', el), calls = $$('.pv-call', el);
    function layout() {
      var W = st.clientWidth, H = st.clientHeight, iw = img.clientWidth || H * 0.68, ih = img.clientHeight || H * 0.88;
      var ix = (W - iw) / 2, iy = (H - ih) / 2, mob = W < 700, svg = '';
      var sides = { '-1': 0, '1': 0 };
      calls.forEach(function (c, i) {
        var px = ix + (+c.getAttribute('data-x') / 100) * iw, py = iy + (+c.getAttribute('data-y') / 100) * ih;
        var side = c.getAttribute('data-side') === 'right' ? 1 : -1, slot = sides[side]++;
        var lx = side < 0 ? (mob ? 4 : W * 0.06) : (mob ? W - 144 : W * 0.72);
        var ly = side < 0 ? [H * 0.1, H * 0.46][slot % 2] : [H * 0.56, H * 0.9][slot % 2];
        if (mob) ly = side < 0 ? [H * 0.03, H * 0.19][slot % 2] : [H * 0.83, H * 0.99][slot % 2];
        var ex = side < 0 ? lx + (mob ? 140 : 230) : lx - 12;
        svg += '<path d="M' + px + ' ' + py + ' L' + ((px + ex) / 2) + ' ' + ly + ' L' + ex + ' ' + ly + '" data-l="' + i + '"/><circle cx="' + px + '" cy="' + py + '" r="6" data-c="' + i + '"/>';
        c.style.left = lx + 'px'; c.style.top = (ly - 24) + 'px'; c.style.textAlign = side < 0 ? 'right' : 'left';
        if (side < 0) c.style.width = (mob ? 136 : 222) + 'px';
      });
      svgEl.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svgEl.innerHTML = svg;
      paths = $$('path', svgEl).map(function (p) { var L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L; p.dataset.len = L; return { el: p, i: +p.dataset.l, len: L, c: $('circle[data-c="' + p.dataset.l + '"]', svgEl) }; });
    }
    var paths = [];
    if (img.complete) requestAnimationFrame(layout); else img.addEventListener('load', layout, { once: true });
    window.addEventListener('resize', layout);
    return {
      frame: function () {
        var ap = pinProg(el);
        img.style.transform = 'translate(-50%,-50%) rotate(' + (-10 + ap * 20) + 'deg) scale(' + (0.9 + Math.sin(ap * Math.PI) * 0.12) + ')';
        paths.forEach(function (p) {
          var i = p.i, t = clamp((ap - 0.12 - i * 0.17) / 0.14, 0, 1);
          p.el.style.strokeDashoffset = p.len * (1 - t);
          if (p.c) p.c.style.opacity = t > 0 ? 1 : 0;
          if (calls[i]) calls[i].classList.toggle('on', t > 0.9);
        });
      },
      destroy: function () { window.removeEventListener('resize', layout); }
    };
  };

  /* =====================================================================
     ROOM MAP
     ===================================================================== */
  mods.map = function (el) {
    var tag = $('[data-tip-tag]', el), title = $('[data-tip-title]', el), text = $('[data-tip-text]', el), spots = $$('[data-spot]', el);
    function spot(k) {
      var s = $('.pv-hot[data-spot="' + k + '"]', el); if (!s) return;
      tag.textContent = s.getAttribute('data-tag'); title.textContent = s.getAttribute('data-title'); text.textContent = s.getAttribute('data-text');
      spots.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-spot') === k); });
    }
    function click(e) { var b = e.target.closest('[data-spot]'); if (b && el.contains(b)) spot(b.getAttribute('data-spot')); }
    el.addEventListener('click', click);
    var first = spots[0]; if (first) spot(first.getAttribute('data-spot'));
    return { destroy: function () { el.removeEventListener('click', click); } };
  };

  /* =====================================================================
     TIMELINE
     ===================================================================== */
  mods.timeline = function (el) {
    var bar = $('.pv-tl__line b', el), steps = $$('.pv-tl__step', el);
    return {
      measure: function () { steps.forEach(rectOf); },
      frame: function (c) {
        var r = rectOf(el), tp = clamp((c.vh * 0.6 - r.top) / Math.max(1, r.height), 0, 1);
        if (bar) bar.style.height = (tp * 100) + '%';
        steps.forEach(function (s) { var sr = rectOf(s); s.classList.toggle('on', sr.top + sr.height / 2 < c.vh * 0.62); });
      }
    };
  };

  /* =====================================================================
     RELATED CAROUSEL (drag + arrows)
     ===================================================================== */
  mods.rel = function (el) {
    var track = $('.pv-rel', el), dragX = null, dragS = 0;
    if (!track) return {};
    function down(e) { if (e.button) return; dragX = e.clientX; dragS = track.scrollLeft; track.classList.add('drag'); }
    function move(e) { if (dragX !== null) track.scrollLeft = dragS - (e.clientX - dragX); }
    function up() { dragX = null; track.classList.remove('drag'); }
    function click(e) { var b = e.target.closest('[data-rel]'); if (b && el.contains(b)) track.scrollBy({ left: (b.getAttribute('data-rel') === 'next' ? 1 : -1) * 380, behavior: 'smooth' }); }
    track.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up); el.addEventListener('click', click);
    return { destroy: function () { window.removeEventListener('mousemove', move); window.removeEventListener('mouseup', up); el.removeEventListener('click', click); } };
  };

  /* =====================================================================
     CART PAGE OFFERS — refresh the section whenever the cart changes
     ===================================================================== */
  mods.cartx = function (el) {
    var id = el.getAttribute('data-section-id'), busy = false;
    function refresh() {
      if (busy || !id) return;
      busy = true;
      fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d = new DOMParser().parseFromString(t, 'text/html'), next = d.querySelector('[data-pv="cartx"]');
          if (next) el.innerHTML = next.innerHTML;
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }
    function onUpdate(e) { if (e.promise) e.promise.then(function () { setTimeout(refresh, 120); }).catch(function () {}); }
    doc.addEventListener('shopify:cart:lines-update', onUpdate);
    return { destroy: function () { doc.removeEventListener('shopify:cart:lines-update', onUpdate); } };
  };

  /* =====================================================================
     GLOBAL: ant cursor, magnetic buttons, add-to-cart flyer
     ===================================================================== */
  /* header: links that don't fit on one line move into a "More" dropdown */
  function setupNavFit() {
    var nav = $('.pvh__links'), more = $('.pvh__more'), menu = more && $('.pvh__more-menu', more);
    if (!nav || !menu) return;
    var links = $$('a', nav), raf = 0;
    function fit() {
      raf = 0;
      links.forEach(function (a) { nav.appendChild(a); });
      more.hidden = true; more.open = false;
      if (getComputedStyle(nav).display === 'none') return;
      if (nav.scrollWidth <= nav.clientWidth + 1) return;
      more.hidden = false;
      for (var i = links.length - 1; i > 0 && nav.scrollWidth > nav.clientWidth + 1; i--) menu.insertBefore(links[i], menu.firstChild);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(fit); }
    fit();
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(queue);
    doc.addEventListener('click', function (e) {
      if (more.open && (!more.contains(e.target) || e.target.closest('.pvh__more-menu a'))) more.open = false;
    });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && more.open) { more.open = false; more.querySelector('summary').focus(); } });
  }

  /* touch screens have no cursor, so a bug wanders the screen instead.
     Hidden while the hero is on screen (it has its own ants); tap near it and it scurries off. */
  function setupWalker() {
    if (FINE || REDUCED || doc.documentElement.getAttribute('data-pv-cursor') === 'off') return;
    var w = doc.createElement('div'), tpl = doc.getElementById('pv-bug-tpl');
    w.className = 'pv-antwalk still'; w.setAttribute('aria-hidden', 'true');
    w.innerHTML = tpl ? tpl.innerHTML : ant(30);
    doc.body.appendChild(w);
    var x = -30, y = window.innerHeight * 0.62, ang = 0, timer = 0, heroIn = false, running = false, SPEED = 55;
    function place(dur, easing) {
      w.style.transition = 'transform ' + dur + 's ' + (easing || 'linear') + ', opacity .4s';
      w.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + ang.toFixed(1) + 'deg)';
    }
    function face(tx, ty) { var a = Math.atan2(ty - y, tx - x) * 180 / Math.PI; ang += ((a - ang + 540) % 360) - 180; }
    function walkTo(tx, ty, speed, done) {
      face(tx, ty);
      w.classList.remove('still');
      place(0.3, 'ease-out');
      timer = setTimeout(function () {
        var t = Math.hypot(tx - x, ty - y) / speed;
        x = tx; y = ty; place(t, 'linear');
        timer = setTimeout(function () { w.classList.add('still'); done(); }, t * 1000);
      }, 300);
    }
    function next() {
      clearTimeout(timer);
      if (heroIn || doc.hidden) { running = false; return; }
      running = true;
      var W = window.innerWidth, H = window.innerHeight;
      walkTo(20 + Math.random() * (W - 40), 90 + Math.random() * (H - 170), SPEED, function () { timer = setTimeout(next, 700 + Math.random() * 2300); });
    }
    function show(on) { w.classList.toggle('on', on); if (on && !running) timer = setTimeout(next, 500); }
    var scene = $('.pv-scene');
    if (scene && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { heroIn = en[0].isIntersecting; show(!heroIn); }).observe(scene);
    } else { place(0); show(true); }
    place(0);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden && !heroIn && !running) next(); });
    /* product pages: tap the bug 3 times and it shows shoppers the Add to cart button,
       sits on it for a second, walks off for a second, then comes back every 7 seconds */
    var PDP = !!$('[data-pv-pdp]'), taps = 0, guiding = false, cycle = 0;
    function atcButton() {
      var list = $$('[data-pv-pdp] button[name="add"], .pv-bar button[name="add"], [data-pv="buybar"] button[name="add"]');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.width && r.bottom > 70 && r.top < window.innerHeight - 20) return { el: list[i], r: r };
      }
      return null;
    }
    function freeze() {
      var r = w.getBoundingClientRect();
      x = r.left + r.width / 2; y = r.top + r.height / 2;
      place(0);
    }
    function visitCart() {
      clearTimeout(cycle); clearTimeout(timer);
      if (heroIn || doc.hidden) { cycle = setTimeout(visitCart, 7000); return; }
      var b = atcButton();
      if (!b) { cycle = setTimeout(visitCart, 7000); if (!running) next(); return; }
      freeze(); running = true;
      /* perch on the top edge of the button, towards the right */
      walkTo(b.r.left + b.r.width * 0.78, b.r.top + 1, 170, function () {
        b.el.classList.add('pv-atc-nudge');
        timer = setTimeout(function () {
          b.el.classList.remove('pv-atc-nudge');
          /* walk off for about a second, then carry on wandering */
          var a = Math.random() * Math.PI * 2, W = window.innerWidth, H = window.innerHeight;
          var tx = clamp(x + Math.cos(a) * 170, 20, W - 20), ty = clamp(y - 60 + Math.sin(a) * 170, 90, H - 80);
          walkTo(tx, ty, 170, function () { timer = setTimeout(next, 600); });
          cycle = setTimeout(visitCart, 7000);
        }, 1000);
      });
    }

    doc.addEventListener('touchstart', function (e) {
      if (!w.classList.contains('on')) return;
      var r = w.getBoundingClientRect(), p = e.touches[0], cx0 = r.left + r.width / 2, cy0 = r.top + r.height / 2;
      if (Math.hypot(p.clientX - cx0, p.clientY - cy0) > 70) return;
      clearTimeout(timer);
      if (PDP && !guiding && ++taps >= 3) { guiding = true; visitCart(); return; }
      /* freeze where it is right now, then dash away from the finger */
      x = cx0; y = cy0;
      var a = Math.atan2(cy0 - p.clientY, cx0 - p.clientX), W = window.innerWidth, H = window.innerHeight;
      var tx = clamp(x + Math.cos(a) * 200, 20, W - 20), ty = clamp(y + Math.sin(a) * 200, 90, H - 80);
      place(0);
      running = true;
      walkTo(tx, ty, 420, function () { timer = setTimeout(next, 1500); });
    }, { passive: true });
  }

  function setupCursor() {
    if (doc.documentElement.getAttribute('data-pv-cursor') === 'off' || !FINE || REDUCED) return;
    cur = doc.createElement('div'); cur.className = 'pv-antcur'; cur.setAttribute('aria-hidden', 'true');
    /* product pages hand over their own cartoon (roach / mosquito); everywhere else it's the ant */
    var tpl = doc.getElementById('pv-bug-tpl');
    cur.innerHTML = tpl ? tpl.innerHTML : ant(34);
    doc.body.appendChild(cur);
    window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; cur.classList.add('on'); }, { passive: true });
    doc.addEventListener('mouseleave', function () { cur.classList.remove('on'); });
  }
  function setupMagnet() {
    if (!FINE || REDUCED) return;
    var sel = '.pv-btn--dark, .pv-btn--lime', active = null;
    doc.addEventListener('mousemove', function (e) {
      var b = e.target.closest && e.target.closest(sel);
      if (active && active !== b) { active.style.transform = ''; active = null; }
      if (!b || b.disabled) return;
      active = b;
      var r = b.getBoundingClientRect();
      b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.15) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.25) + 'px)';
    }, { passive: true });
  }
  var lastSrc = null;
  function setupFlyer() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[name="add"]');
      if (!b) return;
      var root = b.closest('[data-pv-fly]'), sel = root ? root.getAttribute('data-pv-fly') || 'img' : '';
      lastSrc = root ? $(sel, root) || $(sel) || null : null;
    }, true);
    doc.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.action !== 'add' || !e.promise) return;
      var src = lastSrc; lastSrc = null;
      e.promise.then(function () {
        var target = $('.pvh .header-actions__cart-icon');
        if (target) { target.classList.remove('pv-bump'); void target.offsetWidth; target.classList.add('pv-bump'); }
        if (REDUCED || !src || !target) return;
        var a = src.getBoundingClientRect(), b = target.getBoundingClientRect();
        if (!a.width || !src.currentSrc) return;
        var fl = doc.createElement('img'); fl.src = src.currentSrc || src.src; fl.className = 'pv-flyer'; fl.alt = '';
        fl.style.left = (a.left + a.width / 2 - 40) + 'px'; fl.style.top = (a.top + a.height / 2 - 40) + 'px'; doc.body.appendChild(fl);
        var hdr = $('[data-pv-header]'); if (hdr) hdr.classList.remove('hide');
        var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
        var an = fl.animate([
          { transform: 'translate(0,0) scale(1.4) rotate(0)', opacity: 1 },
          { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 120) + 'px) scale(1) rotate(-20deg)', opacity: 1, offset: 0.5 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.2) rotate(-40deg)', opacity: 0.6 }
        ], { duration: 700, easing: 'cubic-bezier(.5,0,.3,1)' });
        an.onfinish = function () { fl.remove(); };
      }).catch(function () {});
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    html.classList.add('pv-js');
    if (!$('.pv-progress')) { var pb = doc.createElement('div'); pb.className = 'pv-progress'; pb.setAttribute('aria-hidden', 'true'); doc.body.appendChild(pb); }
    setupNavFit(); setupCursor(); setupWalker(); setupMagnet(); setupFlyer();
    initRoot(doc);
    requestAnimationFrame(tick);
    doc.addEventListener('shopify:section:load', function (e) { initRoot(e.target); });
    doc.addEventListener('shopify:section:unload', function (e) { destroyRoot(e.target); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
